exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ZbLyJEKRwAkG3s-vpnhKx{position:absolute;width:100%;height:100%;top:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}html[dir] .ZbLyJEKRwAkG3s-vpnhKx{border:0}html[dir=ltr] .ZbLyJEKRwAkG3s-vpnhKx{left:0}html[dir=rtl] .ZbLyJEKRwAkG3s-vpnhKx{right:0}._3yOGbSYIU7c3gJMHBfc0_i{font-size:12px;font-weight:400;color:\"[theme:neutralSecondary, default:#666666]\"}html[dir] ._3yOGbSYIU7c3gJMHBfc0_i{padding-top:20px}", ""]);

// exports
exports.locals = {
	"messageContainer": "ZbLyJEKRwAkG3s-vpnhKx",
	"messageText": "_3yOGbSYIU7c3gJMHBfc0_i"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":{"orderedValues":false}}!./node_modules/postcss-loader/lib?{"plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./obj/options/view/owa-options-view/lib/components/full/OptionsPaneLoading.scss
// module id = 5309
// module chunks = 2